import { Platform, Text, View } from 'react-native'
import React, { Component } from 'react'
// import Model from '../../Model'
import { SHr, SPopup, SText, STheme, SThread, SView, SNotification } from 'servisofts-component2'
import SSocket from 'servisofts-socket'
import MDL from '../../MDL'
import SSwitch from '../SSwitch'

// export default class BarraRastreo extends Component {
class BarraRastreo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: MDL.backgroundLocation.active
        }

    }

    componentDidMount() {
        this.listener1 = MDL.backgroundLocation.addEventListener("changeStatus", (e) => {
            this.setState({ active: e.active })
        })
    }
    componentWillUnmount() {
        MDL.backgroundLocation.removeEventListener(this.listener1)
    }



    handlePress = () => {
        if (!MDL.backgroundLocation.active) {
            MDL.backgroundLocation.start({
                key_usuario: MDL.usuario.session?.lChofer_id,
                plate: MDL.usuario.session?.plate,
            }).then(e => {
                // SNotification.send({
                //     title: "Rastreo iniciado.",
                //     body: "Se ha iniciado el rastreo de tu ubicación.",
                //     color: STheme.color.success,
                //     time: 10000,
                // })
                // SPopup.alert("Se ha iniciado el rastreo de tu ubicación.")
            }).catch(e => {
                console.error(e)
                // SNotification.send({
                //     title: "No se pudo iniciar el rastreo.",
                //     body: e?.error,
                //     color: STheme.color.warning,
                //     time: 10000,
                // })
                // SPopup.alert("Error al iniciar el rastreo.")

            })
        } else {
            MDL.backgroundLocation.stop();
        }
    }

    render() {
        let data = {
            label: "Estás desconectado",
            textColor: STheme.color.white
        }
        if (this.state.active) {
            data = {
                label: "Estás Conectado",
                textColor: STheme.color.white
            }
        }
        return (
            <SView center >
                <SSwitch scale={2.5} color={"#fff"} value={this.state.active} onChange={() => {
                    this.handlePress()
                }} />
                <SHr h={4} />
                <SText fontSize={12} color={data.textColor}>{data.label}</SText>
            </SView>
        )
    }
}
export default BarraRastreo